import { StoreApi, UseBoundStore } from "zustand";
import React, { createContext, useContext } from "react";

// фабрика контекста
export function createApplicationContext<T extends object>() {
  type StoreType = UseBoundStore<T, StoreApi<T>>;

  const Context = createContext<StoreType | null>(null);

  const Provider: React.FC<{
    createStore: () => StoreType;
    children: React.ReactNode;
  }> = ({ createStore, children }) => {
    const store = createStore();
    return <Context.Provider value={store}>{children}</Context.Provider>;
  };

  const useApplicationStore = <S extends T = T>(): UseBoundStore<
    S,
    StoreApi<S>
  > => {
    const ctx = useContext(Context);
    if (!ctx)
      throw new Error("useApplicationStore must be used inside Provider");
    return ctx as UseBoundStore<S, StoreApi<S>>;
  };

  return { ApplicationProvider: Provider, useApplicationStore };
}
